// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface TextCursorIconSignature {
  Element: SVGSVGElement;
}

export const TextCursorIcon: TOC<TextCursorIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path d="M12 3.382C11.266 2.542 10.2 2 9 2H7V4H9C10.103 4 11 4.897 11 6V12H9V14H11V18C11 19.103 10.103 20 9 20H7V22H9C10.2 22 11.266 21.458 12 20.618C12.734 21.458 13.8 22 15 22H17V20H15C13.897 20 13 19.103 13 18V14H15V12H13V6C13 4.897 13.897 4 15 4H17V2H15C13.8 2 12.734 2.542 12 3.382Z"/>
</svg>
</template>;